import React from "react";
import BrandWallItem from "./BrandWallItem";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { IBrandWallItemProps } from "./BrandWallItem.interface";

export interface IBrandWallProps<LinkType = HTMLLinkElement> {
  items: IBrandWallItemProps<LinkType>[];
}

function BrandWall<LinkType>({
  items,
}: IBrandWallProps<LinkType>): JSX.Element {
  const itemsAmount = items.length;

  const { viewportWidth } = useWindowDimensions();
  const isItemsAmountBig = itemsAmount > 10;
  // Calculating of Brands list width including gaps and paddings

  // mobile breakpoint start
  const mobileBreakpoint = 414;
  // gaps between brand icons depending on breakpoint
  const flexGapMobile = 8;
  const flexGapDesktop = 16;
  const gap = viewportWidth > mobileBreakpoint ? flexGapDesktop : flexGapMobile;
  const allGaps = (itemsAmount - 1) * gap;
  // padding of brands wall depending on breakpoint
  const containerXPaddingMobile = 16;
  const containerXPaddingDesktop = 48;
  const xPadding =
    viewportWidth > mobileBreakpoint
      ? containerXPaddingDesktop
      : containerXPaddingMobile;
  // whole itemslist width for calculating items in a row on load
  const itewWidth = 84;
  const listWidth = itemsAmount * itewWidth + allGaps + xPadding;
  // Setting Brand wall width dynamically
  const wallWidth =
    isItemsAmountBig || listWidth > viewportWidth
      ? Math.ceil(itemsAmount / 2) * (itewWidth + gap) + xPadding
      : 1032;
  return (
    <div className="bg-color-grey-100">
      <div
        data-testid="brandwall-testid"
        style={{ maxWidth: `${wallWidth}px` }}
        className="brandwall d-flex flex-wrap mx-auto justify-content-center hstack gap-ms-6 gap-4 py-6 py-lg-9 px-ms-7 px-4"
      >
        {items?.map((item) => (
          <BrandWallItem<LinkType>
            key={item?.id}
            mediaData={item?.mediaData}
            link={item?.link}
          />
        ))}
      </div>
    </div>
  );
}

export default BrandWall;
